import AdminLayout from './AdminLayout';
import AdminPreload from './AdminPreload';
import Preload from './Preload';
import Finish from './Finish';
import Game from './Game';
import Home from './Home';
import UIScene from './UIScene';
import Error from './Error';
import DiceOverlay from './DiceOverlay';
import Reward from './Reward';

export const ALL_SCENES = [
  Preload,
  AdminLayout,
  AdminPreload,
  Finish,
  Game,
  Home,
  UIScene,
  Error,
  DiceOverlay,
  Reward,
];
